import React, { useState, useEffect } from 'react';

interface CountdownProps {
  phien: any;
  setLoad: (value: boolean) => void;
  load: boolean;
}

const CountDownPc: React.FC<CountdownProps> = ({ phien, setLoad, load }) => {
  const initialSeconds: number = phien?.second || 0;
  const [seconds, setSeconds] = useState(initialSeconds);
  const [hasTriggered, setHasTriggered] = useState(false); // Cờ kiểm tra

  // Cập nhật lại seconds khi initialSeconds thay đổi
  useEffect(() => {
    setSeconds(initialSeconds);
    setHasTriggered(false); // Reset cờ khi initialSeconds thay đổi
  }, [phien]);

  useEffect(() => {
    if (seconds > 0) {
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds - 1);
      }, 1000);
      return () => clearInterval(timer); // Cleanup timer
    }

    if (seconds === 0 && !hasTriggered) {
      setHasTriggered(true); // Đảm bảo chỉ gọi một lần
      setLoad(!load);
    }
  }, [seconds, load, hasTriggered, setLoad]);

  const formatTime = (sec: number) => {
    const minutes = Math.floor(sec / 60);
    const remainingSeconds = sec % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds
      .toString()
      .padStart(2, '0')}`;
  };

  return (
    <div className="px-2 py-0 rounded-1" style={{ fontFamily: "Digital",  border: "2px solid rgb(255, 0, 0)", fontSize: 25, color: "rgb(255, 0, 0)", width: 110, letterSpacing: 5 }}>{formatTime(seconds)}</div>
  );
};

export default CountDownPc;
